import { render, staticRenderFns } from "./TabBarItem.vue?vue&type=template&id=de21b3da&scoped=true&"
import script from "./TabBarItem.vue?vue&type=script&lang=js&"
export * from "./TabBarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de21b3da",
  null
  
)

export default component.exports